export default {
  common: {
    adminFunction: "系统管理", //"Administrator function",
    accountManagement: "账号管理",
    accountPermission: "管理用户账号和权限",
    regionManagement: "区域管理",
    zoneCountryCity: "更新地区，国家和城市信息",
    cityWeatherManagement: "城市天气数据",
    weatherProfileBaseOnCity: "更新城市的天气配置文件",
    ecatDataManagement: "Catalog 数据管理",
    ecatLibraryEquipmentsModels: "更新设备 Catalog 数据",
    cancel: "取消",
    save: "保存"
  },
  account: {
    inputUserName: "请输入用户名",
    thereAreNoMoreUsersLeft: "没有更多用户",
    superAdmin: "超级管理员",
    global: "全球的",
    region: "区域",
    zoneCountry: "国家",
    city: "城市",
    segmentMegaCity: "细分（特大城市）",
    status: "账号状态",
    activeStatus: "激活状态",
    role: "账号角色",
    active: "已激活",
    inactive: "未激活",
    fillFormCompletely: "请填写完整"
  }
}



// WEBPACK FOOTER //
// ./src/locale/admin/zh.js